<script setup lang="ts">
import FavoriteProducts from '@/components/about-us/our-family/FavoriteProducts.vue';
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import Header4 from '@/components/base/typography/Header4.vue';

const favoriteProducts = [
  {
    name: 'Roasted Almonds (Salted)',
    url: '/nuts/almonds/roasted-with-salt.html',
  },
  {
    name: 'Roasted Cashews (Salted)',
    url: '/nuts/cashews/roasted-and-salted.html',
  },
  {
    name: 'Chocolate Covered Pretzels',
    url: '/chocolatessweets/moregoodies/chocolate-covered-pretzels.html',
  },
  {
    name: 'Turkish Figs',
    url: '/driedfruit/figs/turkish.html',
  },
  {
    name: 'Jelly Beans',
    url: '/chocolatessweets/moregoodies/jellybeans.html',
  },
  {
    name: 'Turkish Pistachios (Antep)',
    url: '/nuts/pistachios/turkish-antep.html',
  },
  {
    name: 'Roasted Macadamia Nuts (Salted)',
    url: '/nuts/macadamianuts/roasted-and-salted.html',
  },
  {
    name: 'Jumbo Roasted Peanuts (In Shell)',
    url: '/nuts/peanuts/jumbo-roasted-inshell.html',
  },
  {
    name: 'Ultimate Peppah Snacker',
    url: '/gifts/trays/ultimatepeppahsnacker.html',
  },
  {
    name: 'Chocolate Covered Almonds',
    url: '/nuts/almonds/chocolate.html',
  },
];
</script>

<template>
  <div>
    <Header4 headerTag="h3">David</Header4>
    <BaseBodyText>
      <strong>Hi! I'm David,</strong> aka Butt Davis, World's Greatest Cousin, Happy Boy, Bumper
      Beavis, Bumpercrop, and the list goes on (don't ask!). I remember how excited I would get as a
      little boy when my Dad would wake me up to come to work on Saturday mornings. At 5:45 AM I
      would spring out of bed and quickly get dressed in my little work boots and run down the
      stairs to leave. We would go pick up my Uncle Kenneth and cousin Jeffrey and pack into our
      truck with Jeffrey and me sitting on old milk crates. Poppy Sol would get excited to see us at
      work and would immediately reach into his pocket and give me five dollars. That was my hard
      earned pay for the day (in addition to handfuls of gummy bears and hot peanuts I would eat
      throughout the day). The inevitable question would always follow "Are you going to save that
      money or spend it on candy?" I would always tell Poppy I would save it. When breakfast time
      would arrive Poppy Sol would always take Jeffrey and me around the corner to the local diner
      Parker's for breakfast.
    </BaseBodyText>

    <BaseBodyText>
      When it came time to work, I would always do my best to help try and straighten up the shelves
      of groceries with my Uncle Kenneth and fill in our display cases of nuts with my Dad. Although
      my head barely cleared the counter tops I loved waiting on customers and weighing up the nuts
      and dried fruit for them.
    </BaseBodyText>

    <BaseBodyText>
      My favorite time of day would always be when we would roast peanuts. You could smell the fresh
      hot peanuts for blocks. My Dad and Uncle would yell at the top of their lungs "Hot
      Peanuuuuuuuuts" for everyone in Newark to hear. I would then try and hold the empty 50 pound
      sack with my Dad or Uncle and catch the hot peanuts as they came out of the roaster. Smoke and
      peanut ashes would get all in my hair and clothes. I never did mind smelling like peanuts
      though. It was the best smell in the world. Once the hot peanuts came out of the roaster I
      would race Poppy Sol to see who could weigh up the pound bags quicker.
    </BaseBodyText>

    <BaseBodyText>
      As I got older I was allowed to do more unsupervised work in our warehouse with JP and go on
      deliveries with Louis. I would even be the one yelling "Hot Peanuts" and "Get Your Georgia
      Pecans Here." All through high school and college I would come in during winter break to help
      with the holiday rush. During my sophomore year of high school Poppy Sol passed away. I
      remember him coming into work every day right up until he went into the hospital. Even today,
      customers still ask about Poppy Sol. It makes me proud to know how much people cared for him.
    </BaseBodyText>

    <BaseBodyText>
      When I graduated college I began working in the banking industry for a major firm. Less than a
      year working there, Jeffrey joined the business and I knew I wanted to be back with the family
      business full time and carry on Poppy Sol's legacy. He would be very proud to see how much we
      have grown through the years. Today, along with my cousin Jeffrey and the rest of our nutty
      family we strive to bring that same smile to your face that Poppy Sol did since 1929.
    </BaseBodyText>

    <FavoriteProducts :favoriteProducts>
      I love playing soccer, basketball, and softball, rooting for the New York Rangers (season
      ticket holder), the New York Yankees, and the New York Giants, playing with my Mini Pinscher
      named Fritz, listening to music, Fantasy Sports, cooking, and going out in the city with my
      friends.
    </FavoriteProducts>
  </div>
</template>
